import elements from 'modules/overlay-canvas/addons/elements';
import { BasePlaceholder } from '../base';
import { createIndicatorsRow, OrientationEnum, ShapeEnum } from './indicators-row';

class TeamPeriodFouls extends BasePlaceholder {
  create() {
    const { left, top } = elements.getLeftTop(this.canvas);

    const background = this.createRect({
      options: {
        height: 60,
      },
    });

    background.set({
      data: {
        ...background.data,
        id: 'background',
      },
    });

    const data = {
      indicator: 'teamPeriodFouls',
      type: 'composition',
      unground: false,
      teamIndex: 0,
      maxCount: 5,
      shape: ShapeEnum.CIRCLE,
      elementColor: '#FFA500',
      spacing: 0,
      orientation: OrientationEnum.HORIZONTAL,
    };

    // Получаем размеры background
    const backgroundWidth = background.width || 300; // Используем дефолтное значение из BasePlaceholder
    const backgroundHeight = background.height || 60; // Используем дефолтное значение из BasePlaceholder

    // Сначала создаем индикаторы
    const indicators = createIndicatorsRow({
      maxCount: data.maxCount,
      color: data.elementColor,
      spacing: data.spacing,
      orientation: data.orientation,
      shape: data.shape,
      width: backgroundWidth,
      height: backgroundHeight,
    });

    // Создаем группу со всеми объектами сразу
    const group = this.createGroup({
      objects: [background],
      data,
      options: {
        left,
        top,
      },
    });

    indicators.forEach((indicator) => {
      group.add(indicator);
    });

    return group;
  }
}

export default TeamPeriodFouls;
